import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { Fab, Tooltip, useMediaQuery } from "@mui/material";
import { useAppSwipeableDrawer } from '../../store/app-swipable-drawer';
import { Box, Divider, InputLabel } from "@mui/material";
import { canvasControlsHidden } from '../CanvasControls/CanvasControls';
import React from 'react';

export const CropperToolsDialog = () => {
  return (
    <Box sx={{ p: 2 }}>
      {canvasControlsHidden
        .filter((tool) => !tool.disabled)
        .map(({ title, component }, index) => (
          <React.Fragment key={index}>
            <Box sx={theme => ({ 
              display: "flex",
              alignItems: "center", 
            })}>
              <InputLabel
                sx={(theme) => ({
                  marginRight: "8px",
                  fontSize: "1em",
                  color: theme.palette.text.main,
                  opacity: 1,
                  fontWeight: 700,
                })}>
                {title}
              </InputLabel>
              {component}
            </Box>
            {index < canvasControlsHidden.length - 2 && (
              <Divider orientation="horizontal" />
            )}
          </React.Fragment>
        ))}
    </Box>
  );
};

function CanvasControlsTool() {
  const isSM = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const {invokeSwipeableDrawer} = useAppSwipeableDrawer();

  const onClick = () => {
    invokeSwipeableDrawer(
      <CropperToolsDialog />, { title: "Impostazioni" }
    );
  }

  return (
    <>
      {isSM && (
        <Tooltip title="Impostazioni" placement="top">
          <Fab onClick={onClick}>
            <SettingsSuggestIcon />
          </Fab>
        </Tooltip>
      )}
    </>
  )
};

export default CanvasControlsTool;